module.exports = __webpack_public_path__ + "img/39.d00a86af.jpg";